<template>
  <div class="class-popup-backdrop" @click.self="onClickClose">
    <div class="class-popup">
      <div class="popHeader">
        <div class="popHeader-title">계정 관리</div>
        <button class="pop__invisible" @click="onClickClose"></button>
      </div>

      <div class="popContainer__scroll class-popup__body">
        <table class="table_02 class-popup__table">
          <tr>
            <td class="table-field">구분</td>
            <td class="table-field">번호</td>
            <td class="table-field">이름</td>
            <td class="table-field">ID</td>
          </tr>
          <tr v-for="(j, i) in classInfo" :key="i">
            <td class="table-data">{{ j.schoolLevel }}</td>
            <td class="table-data">{{ j.attendanceNumber }}</td>
            <td class="table-data">{{ j.name }}</td>
            <td class="table-data">{{ j.id }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/style/popupStyle.css";
import "../../assets/style/titleStyle.css";
import "../../assets/style/wrapStyle.css";
import "../../assets/style/buttonStyle.css";
import "../../assets/style/inputStyle.css";
import "../../assets/style/dropdownStyle.css";

export default {
  props: {
    classInfo: {
      required: true,
    },
  },
  methods: {
    onClickClose() {
      this.$store.state.classInfoPopupView = false;
      this.$emit("closeEvent");
    },
  },
};
</script>


<!-- <script setup>
import { ref, onMounted, computed, defineProps } from "vue";
import { useStore } from "vuex";
import { onClickOutside } from "@vueuse/core";
import "../../assets/style/popupStyle.css";
import "../../assets/style/titleStyle.css";
import "../../assets/style/wrapStyle.css";
import "../../assets/style/buttonStyle.css";
import "../../assets/style/inputStyle.css";
import "../../assets/style/dropdownStyle.css";

const store = useStore();

const info = defineProps(["classInfo"]);
const info2 = info.classInfo;
const info3 = info2.sort((a, b) => a.attendanceNumber - b.attendanceNumber);
const props = info3;

const onClickClose = () => {
  store.commit("SET_CLASS_INFO_POPUP_VIEW", false);
};
</script> -->

<style scoped>
.class-popup-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(20, 24, 32, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: var(--space-4);
}

.class-popup {
  background: var(--bg-surface-raised);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: classPopupIn 0.18s ease-out;
}

@keyframes classPopupIn {
  from { opacity: 0; transform: translateY(8px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.class-popup :deep(.popHeader) {
  width: 100%;
  display: flex;
  align-items: center;
  padding: var(--space-4) var(--space-5);
  background: var(--bg-surface-raised);
  border-bottom: 1px solid var(--border-default);
}

.class-popup :deep(.popHeader-title) {
  font-size: var(--font-h3-size);
  font-weight: 700;
  color: var(--text-primary);
}

.class-popup :deep(.pop__invisible) {
  margin-left: auto;
}

.class-popup__body {
  padding: var(--space-4) var(--space-5);
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  max-height: none;
}

.class-popup__table {
  width: 100%;
  min-width: 0 !important;
  table-layout: fixed;
}

.class-popup__table :deep(.table-field),
.class-popup__table :deep(.table-data) {
  padding: var(--space-2) var(--space-1);
  word-break: break-all;
  overflow-wrap: anywhere;
  font-size: var(--font-caption-size);
}

/* 컬럼 폭 분배: 구분 / 번호 / 이름 / ID */
.class-popup__table :deep(tr td:nth-child(1)) { width: 18%; }
.class-popup__table :deep(tr td:nth-child(2)) { width: 14%; }
.class-popup__table :deep(tr td:nth-child(3)) { width: 24%; }
.class-popup__table :deep(tr td:nth-child(4)) { width: 44%; }

@media (max-width: 640px) {
  .class-popup-backdrop {
    padding: var(--space-3);
  }
  .class-popup {
    max-width: 100%;
    max-height: calc(100vh - 32px);
  }
  .class-popup__body {
    padding: var(--space-3);
  }
}
</style>